/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerResponse from './CustomerResponse';
import Options from './Options';

/**
* The SearchCustomersResponse model module.
* @module model/SearchCustomersResponse
* @version 2020-12-7
*/
export default class SearchCustomersResponse {
    /**
    * Constructs a new <code>SearchCustomersResponse</code>.
    * 顧客検索レスポンス
    * @alias module:model/SearchCustomersResponse
    * @class
    * @param customers {Array.<module:model/CustomerResponse>} 顧客
    * @param result {module:model/SearchCustomersResponse.ResultEnum} 
    */

    constructor(customers, result) {
        
        
        this['customers'] = customers;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchCustomersResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchCustomersResponse} obj Optional instance to populate.
    * @return {module:model/SearchCustomersResponse} The populated <code>SearchCustomersResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchCustomersResponse();
                        
            
            if (data.hasOwnProperty('customers')) {
                obj['customers'] = ApiClient.convertToType(data['customers'], [CustomerResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * 顧客
    * @member {Array.<module:model/CustomerResponse>} customers
    */
    'customers' = undefined;
    /**
    * @member {module:model/SearchCustomersResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
